import api from './api';

// Sandbox self-servis giriş (docs/superpowers/specs/2026-10-07-sandbox-self-servis-giris-design.md).
// Yanıtların hepsi ResponseObjectModel sarmalıdır: { status, errorCode, message, data }.
//
// ── CANLI (panel.flexbee.app → api2) ───────────────────────────────────────────────────────────
//   GET  /v1/sandbox/info      → { available, sandboxWebUrl, sandboxApiUrl, docsUrl }   (PA.Read)
//   GET  /v1/sandbox/handoffs  → [ { id, userName, createDate } ] — son 100, yeni→eski   (PA.Read)
//   POST /v1/sandbox/handoff   → { url, expiresAt } — 2 dk geçerli, tek kullanımlık      (PA.Write)
// Bunların hata toast'u interceptor'dadır (olağan akış).

export const getSandboxInfo = () => api.get('/v1/sandbox/info');

export const getSandboxHandoffs = () => api.get('/v1/sandbox/handoffs');

export const createSandboxHandoff = () => api.post('/v1/sandbox/handoff');

// ── SANDBOX (test.flexbee.app → api-test) — anonim uçlar ─────────────────────────────────────────
//   POST /v1/sandbox/enter         { token }  → { state:'ready', user } | { state:'provisioning', ticket, companyName }
//   POST /v1/sandbox/enter/status  { ticket } → aynı iki şekil
//
// Giriş sayfası her hatayı KENDİ hata ekranında gösterir; interceptor toast atarsa kullanıcı aynı
// hatayı iki kez görürdü. Üç bayrak birlikte gerekir:
//  - skipErrorToast: hata toast'u yok (sayfa çevirip gösterir);
//  - skipAuthRedirect: olası 401 "oturum düştü" toast'una ve /login'e atmaya dönüşmesin — bu
//    uçlarda henüz oturum YOKTUR, 401 belgenin reddidir;
//  - _skipSelfHeal: 403 (ör. sandbox.suspended) oturum tazeleme denemesi tetiklemesin — tazeleme
//    oturumsuz sayfada 401 alır ve "oturumunuz sona erdi" toast'u + /login yönlendirmesi üretirdi.
// Not: ağ hatası (yanıt yok) toast'u interceptor'da koşulsuzdur; bu bayraklar onu kapatmaz.
const SELF_HANDLED = { skipErrorToast: true, skipAuthRedirect: true, _skipSelfHeal: true };

export const enterSandbox = (token) => api.post('/v1/sandbox/enter', { token }, SELF_HANDLED);

export const getSandboxEntryStatus = (ticket) => api.post('/v1/sandbox/enter/status', { ticket }, SELF_HANDLED);
